import { SHStack, SHTypography } from "@components/design-systems";
import { PageRoutes } from "@constants";
import { generatePath, useNavigate } from "react-router";
import { Link, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
export const UpgradeSubscriptionNotice = () => {
  const navigate = useNavigate();
  const { palette } = useTheme();
  const { user } = useSelector((state: RootState) => state.auth);
  return (
    <SHStack
      display={"flex"}
      gridTemplateColumns={"6.6fr 3.25fr"}
      marginTop={"25px"}
      gap={"15px"}
    >
      <SHTypography variant="subtitle2">
        Please upgrade your subscription
        <Link
          color={palette.text.primary}
          component="a"
          underline="always"
          onClick={() => {
            navigate(
              `${generatePath(PageRoutes.practiceOverview, {
                practiceId: user?.userMetadata?.adviser_firm_id,
              })}/subscription`,
            );
          }}
          sx={{
            paddingX: 0.5,
            cursor: "pointer",
            textDecorationColor: palette.text.primary,
          }}
        >
          here
        </Link>
        to view detailed information, ESG policies, and features for this
        platform
      </SHTypography>
    </SHStack>
  );
};
